import { defaultFilter } from 'cmdk';
import { isEmptyString } from '@/utils/string';

type FilterBySearchTermsOptions<T> = {
  getTerms: (item: T) => readonly string[];
  cap?: number;
  shouldInclude?: (item: T) => boolean;
};

function matchesNormalizedSearchTerms(normalizedQuery: string, terms: readonly string[]): boolean {
  return terms.some((term) => !isEmptyString(term) && defaultFilter(term.toLowerCase(), normalizedQuery) > 0);
}

export function matchesSearchTerms(query: string, terms: readonly string[]): boolean {
  if (isEmptyString(query)) return false;
  return matchesNormalizedSearchTerms(query.toLowerCase(), terms);
}

export function filterBySearchTerms<T>(
  items: readonly T[],
  query: string,
  { getTerms, cap = Number.POSITIVE_INFINITY, shouldInclude = () => true }: FilterBySearchTermsOptions<T>,
): T[] {
  if (isEmptyString(query) || cap <= 0) return [];

  const normalizedQuery = query.toLowerCase();
  const matches: T[] = [];

  for (const item of items) {
    if (!shouldInclude(item)) continue;
    if (!matchesNormalizedSearchTerms(normalizedQuery, getTerms(item))) continue;

    matches.push(item);
    if (matches.length >= cap) break;
  }

  return matches;
}
